import { emptyFragment } from '@execonline-inc/execonline-ui';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { Resource } from '../../../../../Resource/Types';
import { HtmlView } from '../../../Common/Experience';
import { ProductCollection } from '../../../Common/Experience/Types';
import {
  ExperienceSection,
  ExperienceSectionBody,
  ExperienceSectionHeader,
} from '../../Common/ExperienceSection';
import ExperienceUpdateFocus from '../../Common/ExperienceUpdateFocus';
import EnrollmentStore from '../../Enrollment/Store';
import { TileCarouselExperiences } from '../../ExperienceSelection/Experiences/TileViewCarouselExperiences';
import { PromotableSection } from '../PromotableSection';

interface Props {
  data: Resource<ProductCollection>;
  invitationUuid: string;
  enrollmentStore: EnrollmentStore;
}

function PromotableProductCollectionView({ data, invitationUuid, enrollmentStore }: Props) {
  const { payload: productCollection } = data;

  return fromEmpty(productCollection.experiences)
    .map((experienceResources) => (
      <PromotableSection>
        <ExperienceSection>
          <ExperienceSectionHeader>
            <ExperienceUpdateFocus
              productCollection={productCollection}
              scopeType="product-collection"
            />
            {productCollection.description
              .map((description) => (
                <HtmlView
                  description={description}
                  className="mt-4 !text-sm leading-normal text-black sm:!text-lg"
                />
              ))
              .getOrElse(emptyFragment)}
          </ExperienceSectionHeader>
          <ExperienceSectionBody>
            <TileCarouselExperiences
              invitationUuid={invitationUuid}
              experienceResources={experienceResources}
              perPageCount={productCollection.displayPerPageCount}
              enrollmentStore={enrollmentStore}
            />
          </ExperienceSectionBody>
        </ExperienceSection>
      </PromotableSection>
    ))
    .getOrElse(emptyFragment);
}

export default observer(PromotableProductCollectionView);
